<template>
  <div class="wrap">
    <div class="quesDesc">
      <div class="top-left">
        <img class="logo" src="../../assets/images/logo.png" alt="">
        <span style="cursor: pointer;" @click="goBack">百问中心</span>
      </div>
      <div class="top-right">
        <input
        class="searchInput"
        v-model="searchContent"
        placeholder="请输入关键词"
        @keyup.enter='searchFun'
      />
      <i class="el-input__icon el-icon-search"></i>
      </div>
    </div>
    <div class="content">
      <div v-show="showTree" class="side-tree">
      <p style="padding-bottom:0.1rem">所有文章</p>
      <el-tree
        ref="myTree"
        class="menuTree"
        :data="data"
        :props="defaultProps"
        :highlight-current="true"
        node-key="catalogueId"
        :default-expanded-keys="menuKey"
        :expand-on-click-node='false'
        accordion
        @node-click="handleNodeClick"
      >
      <div slot-scope="{node,data}" class="trees">
      <span><span v-if="data.isArticle === '01'"
              ><i class="el-icon-document"></i
            ></span>{{node.label}}</span>
    </div>
  </el-tree>
    </div>
    <div class="right">
      <div class="breadcrumb">
        <span v-for="(item, index) in searchArticlePath" :key="index" @click="pathNameFun(item, index)"
          >{{ item.pathName }}<span class="arrow el-icon-arrow-right"></span>
        </span>
      </div>
      <div class="detail" v-if="this.menuId">
        <h1>{{menuTitle}}</h1>
        <div class="tip">
          <img
            :src="require(`@/assets/images/tip.png`)"
            alt=""
            class="shallow"
          />点击以下关键词，可直接跳转至相应操作说明
        </div>
        <ul v-if="articleList.length">
          <li
            v-for="(item, index) in articleList"
          :key="index"
          @click="detail(item)"
          class="articleListStyle flex alignItems spaceBetween"
          ><span>{{item.catalogueName}}</span></li>
        </ul>
        <div class="noData" v-if="!articleList.length">暂无数据</div>
      </div>
      <div class="article" v-if="this.articleId">
        <p class="title">{{ article.articleTitle }}</p>
        <p class="article-content" v-html="article.articleContent" ref="editorContent"></p>
          <!-- 右侧导航栏 -->
          <div class="article_navbar">
           <h4 class="navBar_title" style="font-weight:bold">本章目录</h4>
           <div class="navBar_main">
            <a v-for="(item, index) in NavList" :id="item.directoryUrl" :key="index" @click="goAnchor(item)">
              {{ item.directoryName }}
            </a>
          </div>
        </div>
      </div>
    <div class="noData" v-if="!this.articleId && !this.menuId">暂无数据</div>
    </div>
    </div>
    <div v-show="showTree" class="btn-expand" @click="doExpand">
      <img class="btn-left" src="../../assets/images/left.png" alt="">
    </div>
    <div v-show="!showTree" class="btn-expand2" @click="doExpand">
      <img class="btn-right" src="../../assets/images/right.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name:'menuPad',
  data () {
    const _that = this
    return {
      drawer: false,
      direction: 'ltr',
      searchContent: '',
      data: [],
      defaultProps: {
        children: 'childList',
        label: 'catalogueName'
      },
      menuKey:'',
      detailId:'',
      menuTitle:'',
      titleList:[],
      articleType:'',
      searchArticlePath: [],
      articleList: [],
      articleId:'',
      menuId:'',
      article:{},
      showTree:true,
      searchContent:'',
      articleContent:'', //文章内容
      NavList: [
        {
          'articleId':'',//id
          'directoryName': '', // 导航名称
          'directoryUrl': '', // 导航路径
          'orderNum': 0 // 排序号
        }
      ]
    }
  },
  mounted () {
      this.menuTitle = localStorage.catalogueName
      this.menuId = this.$route.query.menuId
      // if(this.menuId == ''){
      //   this.menuId = 'ba2'
      //   this.menuTitle = '入门必读'
      // }else{
      //   this.menuId = this.$route.query.menuId
      // }
      this.articleId = this.$route.query.articleId
      if (this.articleId) {
        this.initArticle()
      }
       else if (this.menuId) {
        this.initMenu()
        this.searchArticlePathFun()
      }
      setTimeout(()=>{
        if(this.detailId){
          this.$refs.myTree.setCurrentKey(this.detailId)
        }
    },500)
  },
  created () {
    this.getMenu()
    if(!this.menuKey){
      this.menuKey=JSON.parse(sessionStorage.getItem('menuIds'))
    }
    if(!this.detailId){
      this.detailId=JSON.parse(sessionStorage.getItem('menuIds')).slice(-1)[0]
    }
  },
  methods: {
    dataSearch (list) {
      list.forEach(item => {
        if (item.catalogueId === this.currentPath) {
          if (this.currentIsArticle === '02') {  //目录
            this.menuId = item.catalogueId
            this.articleId = ''
            this.articleList = item.childList
          } else if (this.currentIsArticle === '01') {//文章详情
            this.articleId = item.catalogueId
            this.menuId = ''
            this.article = item.childList
          }
          return
        } else {
          if (item.childList) {
            this.dataSearch(item.childList)
          }
        }
      })
    },
    detail (item) {
      this.loading = true
      if (item.isArticle === '02') {
        this.articleList = item.childList
        this.articleId = ''
        this.menuId = item.catalogueId
        this.menuTitle = item.catalogueName
        this.searchArticlePathFun()
      } else if (item.isArticle === '01') {
        this.articleId = item.catalogueId
        this.initArticle()
        this.menuId = ''
        this.articleId = item.articleId
      }
    },
    goBack(){
      this.$router.push('/homePC')
    },
    search(){
      this.$router.push('/searchPC')
      localStorage.searchContent = ''
    },
    // 通过id查询目录
    searchArticlePathFun () {
      let params = {
        "articleCatalogueId": this.menuId,
        "articleId": this.articleId
      }
      this.$http.post(this.$url.searchArticlePath, params)
        .then((res) => {
          if (res.data.isSuccess) {
            const ids = []
            this.searchArticlePath = res.data.pathList
            res.data.pathList.map(item=>{
              ids.push(item.path)
              sessionStorage.setItem('menuIds', JSON.stringify(ids))
              this.menuKey=JSON.parse(sessionStorage.getItem('menuIds'))
              this.detailId=JSON.parse(sessionStorage.getItem('menuIds')).slice(-1)[0]
            })
          }
        })
    },
    // 通过目录id 查询文章列表
    initMenu () {
      let params = {
        "catalogueId": this.menuId
      }
      this.$http.post(this.$url.searchArticleList, params)
        .then((res) => {
          if (res.data.isSuccess) {
            res.data.articleList.forEach(item => {
              item.catalogueName = item.articleTitle
              item.catalogueId = item.articleId
              item.isArticle = '01'
            })
            this.articleList = res.data.articleList
            this.articleId = ''
          }
        })
    },
    //根据文章id查询文章
    initArticle () { 
      let params = {
        "articleId": this.articleId,
      }
      this.$http.post(this.$url.getArticleByArticleId, params)
        .then((res) => {
          if (res.data.isSuccess) {
            this.article = res.data.article
            this.menuId = ''
            this.articleId = res.data.article.articleId
            this.NavList=res.data.list
            this.drawer = false
            this.searchArticlePathFun() 
            this.menuTitle = this.article.articleTitle
            this.createArticleClick(params.articleId)
          }
        })
    },
    // 点击导航跳转
    goAnchor(anchor){
      const top = this.$refs.editorContent.childNodes[anchor.orderNum].offsetTop
      document.getElementsByClassName('article')[0].scrollTop = top - 70
    },
    // 添加点击量
    createArticleClick(id){
      let params = {
        "articleId": id,
        "userId": localStorage.userInfo ? JSON.parse(localStorage.userInfo).workCode : '',
        "userName": localStorage.userInfo ? JSON.parse(localStorage.userInfo).name : ''
      }

      this.$http.post(this.$url.createArticleClick, params)
        .then((res) => {
        //  console.log(res);
        })
    },
    getMenu(){
      const params = { affiliationCompanyId:111 }
        this.$http.post(this.$url.searchArticleCatalogueTree, params)
        .then((res) => {
          this.data = res.data.articleCatalogueInfo
        })
    },
    handleNodeClick (data) {
      // console.log(data.catalogueId);
      this.$router.push({path:'/menuPC', query: { articleId: data.catalogueId }})
      this.menuTitle = data.catalogueName
      if (data.isArticle === '02') { //目录
        this.menuId = data.catalogueId
        this.articleList = data.childList
        this.articleId = ''
        this.drawer = false
        this.searchArticlePathFun()
      } else if (data.isArticle === '01') { //文章详情
        this.menuId = ''
        this.articleId = data.catalogueId
        this.initArticle()
      }
    },
    doExpand() {
      this.showTree = !this.showTree
    },
    searchFun () {
      localStorage.searchContent = this.searchContent
      this.$router.push({ path: '/searchPC' })
    },
    pathNameFun (param, index) {
      this.menuTitle = param.pathName
      if (this.searchArticlePath.length !== (index + 1)) {
        this.currentPath = param.path
        this.currentIsArticle = param.isArticle
        this.dataSearch(this.data)
        this.searchArticlePathFun()
      }
    }
  }
}
</script>
<style>
.el-tree-node.is-current > .el-tree-node__content {
    color: #026EBA;
  }
</style>
<style lang="less" scoped>
.wrap{
  width: 100%;
  height: 100%;
  .btn-expand {
      cursor: pointer;
      width: .3rem;
      height: .3rem;
      background: #ffffff;
      position: absolute;
      top: 1.9rem;
      left: 2.83rem;
      // border-radius: 50%;
      // border: 1px solid #DEE0E3;
      .btn-left{
        width: .3rem;
      }
  }

  .btn-expand2 {
    cursor: pointer;
    width: .3rem;
    height: .3rem;
    background: #ffffff;
    position: absolute;
    top: 1.9rem;
    left: 0;
    // border-radius: 0 0.12rem 0.12rem 0;
    // border: 1px solid #DEE0E3;
    .btn-right{
        width: .3rem;
      }
  }
}
.articleListStyle{
  span{
    cursor: pointer;
  }
  span:hover{
    color: #026EBA;
    text-decoration-color: #026EBA;
    text-decoration:underline;
  }
}
.quesDesc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: .2rem;
    font-weight: 5px;
    text-align: center;
    height: 0.6rem;
    // letter-spacing: 1px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    float: left;
    width: 100%;
    .logo{
      padding: 0 0.1rem 0 0.2rem;
      width: 2.5rem;
      border-right: 1px solid #C4C4C4;
    }
    span{
      margin-left: 0.1rem;
      font-size: 0.16rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .top-right {
      position: relative;
      width: 30%;
      margin-right: 3%;
      .searchInput {
        width: 100%;
        height: 0.36rem;
        font-size: 0.16rem;
        border-radius: 0.1rem;
        padding-left: 0.3rem;
        border: 1px solid #C4C4C5;
      }
      .el-input__icon {
        width: 0.3rem;
        line-height: 35px;
        font-size: 0.16rem;
        position: absolute;
        left: 0px;
        color: #8c8c8c;
        font-weight: bold;
      }
    }
  }
  ::v-deep .el-tree-node__content{
  height: auto !important;
  margin-bottom: 0.1rem;
}
.trees{
  width: 100%-.1rem;
  overflow: hidden;
  span{
    font-size: .14rem;
    white-space: pre-wrap;
  }
  .tree-icon{
    width: 0.12rem;
    margin-right: 5px;
    margin-top: -4px;
  }
}
.content {
  width: 100%;
  height: calc(100% - 0.6rem);
  background: #fff;
  padding-bottom: 20px;
  display: flex;
  ::v-deep .el-breadcrumb__inner {
    font-size: 0.15rem;
  }
  .side-tree{
    padding: .3rem .2rem 0 .2rem ;
    height: 100%;
    position: relative;
    width: 3rem;
    font-size: .14rem;
    border-right: 1px solid #DEE0E3;
    .menuTree{
      height: 95%;
      overflow: auto;
    }
  }
  .right{
    overflow:hidden;
    position: relative;
    flex:1;
    margin-left: 0.2rem;
  }
  .breadcrumb {
    padding: 0.3rem 0.1rem;
    font-size: 0.14rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    .arrow{
      line-height: 0.12rem;
    }
  }
  .breadcrumb span{
    cursor: pointer;
  }
  .breadcrumb span:hover{
    color: #026EBA;
    text-decoration:underline;
    text-decoration-color: #026EBA;
  }

  .breadcrumb span .arrow{
    cursor: default;
  }

  .breadcrumb span:last-child {
    cursor: text;
  }
  .breadcrumb span:last-child:hover {
    cursor: text;
    text-decoration:none;
    color: #000000;
  }
  
  .breadcrumb span:last-child .arrow {
    display: none;
  }
  .drawallArticle {
    ::v-deep .el-drawer__body {
      position: relative;
      padding-left: 10px;
      overflow: auto;
      ::v-deep .el-tree-node.is-current > .el-tree-node__conten {
        color: #026eba;
      }

      .el-tree-node__content:hover,
      .el-upload-list__item:hover {
        background-color: #fff;
        // color: #026eba;
      }
      .el-tree {
        // position: absolute;
        // padding-top: 0.4rem;
        // top: 0.15rem;
        // left: 0;
        // right: 0.15rem;
        // width: 100%;
        margin-top: 45px;
        height: calc(100% - 45px);
        overflow: auto;
      }
    }
    ::v-deep .el-drawer__header {
      font-size: 0.16rem;
      font-weight: bold;
      margin-bottom: 0px;
      padding: 10px;
    }
  }
  .detail {
    padding-left: 0.11rem;
    background: #fff;
    height: 72%;
    ul {
      height: 100%;
      overflow: auto;
      li {
        padding: 0.1rem 0rem;
        font-size: 0.14rem;
        text-decoration: underline;
      }
    }
    // .active {
    //   color: #026eba;
    //   text-decoration: underline;
    // }
    .tip {
      padding: 0.2rem 0rem;
      color: #666666;
      font-size: 0.14rem;
      img {
        width: 0.12rem;
        margin-right: 5px;
        margin-top: -4px;
      }
    }
    h1 {
      font-size: 0.2rem;
    }
  }
  .right{
    height: 100%;
    padding-right: 3rem;
  }
  .article {
    height: 90%;
    padding: 10px;
    overflow: auto;
    .title {
      font-size: 0.24rem;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .article-content {
      font-size: 0.16rem;
      line-height: 0.4rem;
    }
    .article_navbar{
      width:200px;
      height: 80%;
      position: fixed;
      top:150px;
      right:30px;
      overflow-y:auto;
      border-left:1px solid #ccc;
      .navBar_title{
       width: 100%;
       padding: 5% 10%;
       font-size: 16px;
       text-align: center;
        }
       .navBar_main{
       display: flex;
       flex-direction: column;
       font-size:14px;
       cursor: pointer;
        a{
         margin:10px 20px
        }
     }
    }
  }
  ::v-deep .el-drawer__wrapper {
    top: 45px;
    .el-tree-node__content {
      height: 0.4rem;
    }
    .el-tree-node__label {
      font-size: 0.14rem;
    }
  }
  .searchSection {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    width: 100%;
    padding: 0.16rem 0.1rem;
    border-bottom: 1px solid #ddd;
    // box-shadow: 2px 2px 10px #ddd;
    ::v-deep .el-input {
      width: 90%;
    }
    ::v-deep .el-input__inner {
      height: 0.3rem;
      line-height: 0.3rem;
      font-size: 0.14rem;
      border: none;
      border-bottom: 1px solid #dcdfe6;
      border-radius: 0;
    }
    .el-icon-search {
      font-size: 0.18rem;
      font-weight: bold;
      color: #666666;
    }
    img {
      height: 0.16rem;
      margin-top: 0.07rem;
    }
  }
  .noData{
      font-size: 0.18rem;
    }
}
</style>